<template>
  <div :style="{ width: displayInline ? 'fit-content' : '100%', display: displayInline ? 'inline' : 'block' }">
    <div class="checkbox-childrens-input-container">
      <div class="primary-checkbox-container">
        <Field
          v-slot="{ field }"
          v-model="mutatedValue"
          :label="label"
          :name="name"
          :rules="validation"
        >
          <input
            :id="name"
            :ref="name"
            type="checkbox"
            v-bind="field"
            :disabled="isReadOnly"
            @change="onChange"
          >
          <label :for="name">{{ placeholder }}</label>
          <ErrorMessage
            class="error-msg"
            :name="name"
          />
        </Field>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
/**
 * Props:
 * label: label displayed (string),
 * name: input name (string)
 * value: if the checkbox is checked or not (Boolean)
 */
export default {
  name: 'InputBlockCheckbox',
  components: { Field, ErrorMessage },
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: String,
    defaultValue: {
      type: [Object, Boolean]
    },
    name: String,
    displayInline: Boolean,
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['addData', 'checkBoxChildrenShow'],
  data() {
    return {
      mutatedValue: this.defaultValue
    }
  },
  mounted() {
    this.$emit('addData', { value: {}, name: this.name })

    // If this.defaultValue prop is a object, we have to check if at least one of the value is true to set the inputBlockCheckbox to true
    if (typeof this.defaultValue === 'object') {
      if (Object.values(this.defaultValue).every(x => x === false)) {
        this.mutatedValue = false
        this.$emit('checkBoxChildrenShow', { name: this.name, value: false })
      } else {
        this.mutatedValue = true
        this.$emit('checkBoxChildrenShow', { name: this.name, value: true })
      }
    } else {
      this.$emit('checkBoxChildrenShow', { name: this.name, value: this.defaultValue })
    }
  },
  methods: {
    onChange(e) {
      this.$emit('addData', { value: {}, name: this.name })
      this.$emit('checkBoxChildrenShow', { name: this.name, value: e.target.checked })
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkbox-childrens-input-container {
    display: flex;
    padding: 10px 10px 10px 0;
    flex-wrap: wrap;

    input {
      border-radius: 0;
      position: relative;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      margin-right: 8px;
      border: 1px black solid;
      min-height: 1rem;
      min-width: 1rem;
      background-color: transparent;
      transition: 0.3s;

      @media only screen and (width >= 768px) {
        min-height: 1.5rem;
        min-width: 1.5rem;
      }

      /* Desktops and laptops */
      @media only screen and (width >= 1024px) {
        min-height: 1.5rem;
        min-width: 1.5rem;
      }

      /* Large screens */
      @media only screen and (width >= 1824px) {
        min-height: 1.75rem;
        min-width: 1.75rem;
      }
    }

    input:checked {
      background-color: black;
      transition: 0.3s;
    }

    input:disabled {
      background-color: rgb(189 189 189);
    }

    .primary-checkbox-container {
      display: flex;
      align-items: center;
      flex-wrap: inherit;
      padding-bottom: 10px;
    }

    .childrens-checkbox-container {
      display: flex;
      align-items: center;
      margin: 10px 20px;
    }

    @media screen and (width >= 699px) {
      .first-child {
        margin-left: 60px;
      }
    }
  }
</style>
